module.exports = __webpack_public_path__ + "images/56796c64bab4651d8349c7a0f7e45f31.webp";